

/**
 * Created by Astha on 12/22/2017.
 */
import {
  UserDetails,
  EditUserFromWebClientQuery,
  EditUserFromWebClientMessage
} from "./../../autogenerated/ZoomBridge";
import { Logger } from './../../logger/Logger';

export default class EditUser {
  constructor() {
    this.logger = new Logger('EditUser');
  }


  /**
   *
   * @param {string} userId
   * @param {string} oldPassword
   * @param {string} newPassword
   */
  editUser(userId,oldPassword,newPassword, profileFileId, profilePicName,isImageRemoved){
    const query = new EditUserFromWebClientQuery();
    const message = new EditUserFromWebClientMessage();
    message.setUserDetails(new UserDetails().setProfileFileId(profileFileId).setProfilePicName(profilePicName).setUserId(userId));
    message.setOldPassword(oldPassword);
    message.setNewPassword(newPassword);
    message.setIsImageRemoved(isImageRemoved);
    query.message = message;
    return query.run(true);
  }

}
